// src/components/ControlPanel.js
import React from 'react';
import { useOpenVidu } from '../contexts/OpenViduContext';

export const ControlPanel = () => {
  const { 
    isConnected, 
    toggleAudio, 
    toggleVideo, 
    leaveSession, 
    publisher,
    isMobile,
    mediaSource,
    switchMediaSource
  } = useOpenVidu();

  if (!isConnected) return null;

  const buttonStyles = {
    base: {
      border: 'none',
      borderRadius: isMobile ? '50%' : '20px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: '600',
    },
    mobile: {
      width: '60px',
      height: '60px',
      fontSize: '20px',
      margin: '0 8px',
    },
    desktop: {
      padding: '12px 20px',
      fontSize: '16px',
      margin: '0 5px',
    },
    active: {
      background: '#007bff',
      color: 'white',
    },
    muted: {
      background: '#dc3545',
      color: 'white',
    },
    leave: {
      background: '#dc3545',
      color: 'white',
    },
    switch: {
      background: '#28a745',
      color: 'white',
    }
  };

  const getButtonStyle = (type, isActive = true) => {
    const style = {
      ...buttonStyles.base,
      ...(isMobile ? buttonStyles.mobile : buttonStyles.desktop)
    };
    
    switch (type) {
      case 'audio':
        return { ...style, ...(isActive ? buttonStyles.active : buttonStyles.muted) };
      case 'video':
        return { ...style, ...(isActive ? buttonStyles.active : buttonStyles.muted) };
      case 'leave':
        return { ...style, ...buttonStyles.leave };
      case 'switch':
        return { ...style, ...buttonStyles.switch };
      default:
        return style;
    }
  };

  return (
    <div style={{
      position: isMobile ? 'fixed' : 'fixed',
      bottom: isMobile ? '20px' : '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: isMobile ? '8px' : '10px',
      padding: isMobile ? '16px' : '15px',
      background: 'rgba(255,255,255,0.95)',
      borderRadius: isMobile ? '40px' : '25px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
      backdropFilter: 'blur(10px)',
      zIndex: 1000,
      flexWrap: isMobile ? 'nowrap' : 'wrap',
      justifyContent: 'center',
      maxWidth: isMobile ? '90vw' : 'none',
      overflowX: isMobile ? 'auto' : 'visible',
    }}>
      {/* Audio Toggle */}
      <button
        onClick={toggleAudio}
        style={getButtonStyle('audio', publisher?.stream?.audioActive)}
        title={publisher?.stream?.audioActive ? 'Mute Audio' : 'Unmute Audio'}
      >
        {publisher?.stream?.audioActive ? '🎤' : '🔇'}
        {!isMobile && (publisher?.stream?.audioActive ? ' Mute' : ' Unmute')}
      </button>
      
      {/* Video Toggle */}
      <button
        onClick={toggleVideo}
        style={getButtonStyle('video', publisher?.stream?.videoActive)}
        title={publisher?.stream?.videoActive ? 'Stop Video' : 'Start Video'}
      >
        {publisher?.stream?.videoActive ? '📹' : '📷❌'}
        {!isMobile && (publisher?.stream?.videoActive ? ' Stop Video' : ' Start Video')}
      </button>
      
      {/* Media Source Switch (Desktop only) */}
      {!isMobile && (
        <button
          onClick={() => switchMediaSource(mediaSource === 'screen' ? 'camera' : 'screen')}
          style={getButtonStyle('switch')}
          title={mediaSource === 'screen' ? 'Switch to Camera' : 'Switch to Screen Share'}
        >
          {mediaSource === 'screen' ? '📷 Camera' : '🖥️ Screen'}
        </button>
      )}
      
      {/* Leave Session */}
      <button
        onClick={leaveSession}
        style={getButtonStyle('leave')}
        title="Leave Session"
      >
        📞{!isMobile && ' Leave'}
      </button>
    </div>
  );
};
